import { Autocomplete, Box, InputBase, Typography } from "@mui/material";
import { useCallback, useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppConfigsFeature } from "../../features/app-configs";

export const LicensesSelect = ({ label, name, value, onChange, error, helperText, multiple = false }) => {
  const dispatch = useDispatch();
  const [licenseTypeOptions, setLicenseTypeOptions] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [fetching, setFetching] = useState(false);

  const updateLicenseTypeOptions = useCallback(
    async (search) => {
      setFetching(true);
      const options = await AppConfigsFeature.fetchLicenseTypes({ search })(dispatch);
      setLicenseTypeOptions(options);
      setFetching(false);
    },
    [dispatch]
  );

  useLayoutEffect(() => {
    let active = true;

    if (!initialized) {
      updateLicenseTypeOptions("").then(() => {
        if (active) {
          setInitialized(true);
        }
      });
    }

    return () => {
      active = false;
    };
  }, [dispatch, initialized, updateLicenseTypeOptions]);

  const handleChange = async (_, value) => {

    onChange({ target: { name, value } });
  };

  return (
    <Box sx={{ my: "0.8rem" }}>
      {label && <Typography sx={{ fontWeight: "bold", mb: "0.6rem" }}>{label}</Typography>}
      <Autocomplete
        sx={{ borderRadius: "4px", backgroundColor: "#F4F4FB", paddingRight: "1rem" }}
        onChange={handleChange}
        multiple={multiple}
        defaultValue={multiple ? [] : null}
        value={value}
        options={licenseTypeOptions}
        loading={fetching}
        isOptionEqualToValue={(option, value) => {
          return `${option.country} - ${option.issuer}` === `${value.country} - ${value.issuer}`;
        }}
        getOptionLabel={(option) => {
          return `${option.country} - ${option.issuer}`;
        }}
        renderOption={(props, option) => {
          return (
            <Box value={option} {...props}>
              {option.country} - {option.issuer}
            </Box>
          );
        }}
        renderInput={(params) => {
          const { InputLabelProps, InputProps, ...rest } = params;
          return (
            <InputBase
              {...InputProps}
              {...rest}
              // onChange={({ target }) => updateLicenseTypeOptions(target.value)}
              placeholder="Please enter the country name"
              sx={{ padding: "0.44rem 0.88rem" }}
            />
          );
        }}
      />
      {helperText && (
        <Typography variant="subtitle2" sx={{ m: "0.6rem", color: error ? "red" : "black" }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};
